module.exports = __webpack_public_path__ + "static/media/meditacoes-active.2d61cbd3.png";